import React from 'react'
import { Box } from '@node-space/ui-components'
import { ContactsSearch } from 'components/Contacts/ContactsSearch'
import { ContactAtomType } from 'types/atoms/atom.contacts'

export const MassPayoutContactSearch = () => {
  return (
    <Box width="full">
      <ContactsSearch atomType={ContactAtomType.MASS_PAYOUT_CONTACT_ACTION} />
    </Box>
  )
}
